import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Tag } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/shop`;

// "Also known as" names for one employee — what the Daily PSI crew matcher will accept as this person.
export const KnownAsField = ({ member }) => {
  const [value, setValue] = useState((member?.aliases || []).join(', '));
  const [saving, setSaving] = useState(false);
  useEffect(() => { setValue((member?.aliases || []).join(', ')); }, [member?.id, member?.aliases]);
  const dirty = value.trim() !== (member?.aliases || []).join(', ').trim();

  const save = async () => {
    setSaving(true);
    try {
      const r = await axios.put(`${API}/employee-aliases/${member.id}`, { aliases: value.split(',').map(s => s.trim()).filter(Boolean) });
      member.aliases = r.data.aliases;
      setValue(r.data.aliases.join(', '));
      const n = r.data.converted?.length || 0;
      const c = r.data.clashes?.length || 0;
      toast.success(`Known-as names saved${n ? ` · ${n} past PSI contractor row${n === 1 ? '' : 's'} re-linked to ${member.full_name}` : ''}${c ? ` · ${c} day${c === 1 ? '' : 's'} need a PM merge (already had hours)` : ''}`, { duration: 7000 });
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not save'); }
    setSaving(false);
  };

  return (
    <div className="sm:col-span-2" data-testid="known-as-field">
      <label className="block text-xs font-medium text-slate-600 mb-1 flex items-center gap-1"><Tag className="w-3 h-3" /> Also known as (PSI crew names)</label>
      <div className="flex gap-2">
        <input value={value} onChange={e => setValue(e.target.value)} placeholder='e.g. Alwin Thomas, AJ' data-testid="known-as-input"
          className="flex-1 px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none" />
        <button onClick={save} disabled={!dirty || saving} data-testid="known-as-save"
          className="px-3 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-40 text-white rounded-lg text-sm font-medium">{saving ? '…' : 'Save'}</button>
      </div>
      <p className="text-[11px] text-slate-500 mt-1">Comma-separated. When a foreman types one of these on a Daily PSI crew list, the hours land on {member?.full_name || 'this person'} instead of a contractor row. Saving also re-links past contractor rows typed this way.</p>
    </div>
  );
};
